import remove_markdown from 'remove-markdown';
export function stripMarkdown(md) {
  var plainText = remove_markdown(md, {
    stripListLeaders: false
  });
  return plainText;
}
//# sourceMappingURL=markdownStripUtil.js.map
